<template>
<div class="dropdown" style="width: 100%;">
    <button class="btn btn-secondary dropdown-toggle utilaj_item" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" >
        {{utilaj.categorie_denumire}}: {{ utilaj.element }} [{{ utilaj.um_denumire }}]
    </button>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1" style="width: 100%;" @click="sterge_filtru">
            <input type="search" class="form-control search" placeholder="Selecteaza..." autofocus="autofocus" v-model="cauta_utilaj"
            @keyup="filter_($event.target.value.toUpperCase());">
        <li><a class="dropdown-item utilaj_item" v-for="option in options" v-bind:key="option.id" href="#" @click="selecteaza(option)">{{option.categorie_denumire}}: {{ option.element }} [{{ option.um_denumire }}]</a></li>
    </ul>
</div>
</template>

<script>
export default {
        name: 'FSearchSelect',
        data () {
                return {
                        selected: "Favorite",
                        cauta_utilaj: '',
                }
        },
        props: ["options", "utilaj"],
        methods:{
                selecteaza: function(dictionar){
                        this.$emit('lucrare_selectata', dictionar)
                },
                filter_ : function(filtru){
                        var b = document.getElementsByClassName("utilaj_item");
                        for( var i =0; i< b.length; i++){ 
                                b[i].style.display = b[i].textContent.toUpperCase().indexOf(filtru) > -1 ? "" : "none";
                        }
                },
                sterge_filtru: function(){
                        this.cauta_utilaj= '';
                        this.filter_(this.cauta_utilaj);
                }
        }
}
</script>

<style scoped>
.utilaj_item {
    display: block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>